// components/Mailchimp.js
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import MailchimpForm from "./MailchimpForm";
import NewsletterButton from "./NewsletterButton";

const Mailchimp = () => {
  const [showModal, setShowModal] = useState(false);
  const url =
    "https://seinimlicht.us14.list-manage.com/subscribe/post?u=cd8352ba2bcaff006aa5a70c0&id=532b567a4d";

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

 useEffect(() => {
	const newsletterModalShown = sessionStorage.getItem("newsletterModalShown");
		if (!newsletterModalShown) {
        const timer = setTimeout(() => {
            setShowModal(true);
			sessionStorage.setItem("newsletterModalShown", "true");
        }, 5000);
        return () => clearTimeout(timer);
	}
    }, []);


  return (
    <>
      <div className="mail-chimp-background">
        <section>
          <Container>
            <Row className="mail-chimp-background-inside">
              <Col>
                <div
                  style={{
                    marginTop: "30px",
                    fontWeight: "bold",
                    fontSize: "30px",
                    textTransform: "uppercase",
                  }}
                >
                  Melde Dich an zum Newsletter „LICHTBLICK“
                </div>
                <p>
                  Melde Dich mit deiner E-Mail-Adresse an und erhalte alle
                  Neuigkeiten, Updates und aktuellen Events über meinen Newsletter.
                </p>

                <Button onClick={openModal}>ANMELDEN</Button>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <MailchimpSubscribe
        url={url}
        render={({ subscribe, status, message }) => (
          <MailchimpForm
            show={showModal}
            onHide={closeModal}
            status={status}
            message={message}
            onValidated={(formData) => subscribe(formData)}
          />
        )}
      />
      <NewsletterButton onOpen={openModal} />
    </>
  );
};

export default Mailchimp;
